<div class="select-datepicker-list">
  <div class="select-datepicker-list__buttons">

      <button
              mat-icon-button
              class="select-datepicker-list__button"
              [ngClass]="{'select-datepicker-list__button--disabled': prevPageDisabled}"
              [disabled]="prevPageDisabled"
              (click)="prev()"
      >
          <mat-icon>keyboard_arrow_left</mat-icon>
      </button>

      <button
              mat-icon-button
              class="select-datepicker-list__button"
              [ngClass]="{'select-datepicker-list__button--disabled': nextPageDisabled}"
              [disabled]="nextPageDisabled"
              (click)="next()"
      >
          <mat-icon>keyboard_arrow_right</mat-icon>
      </button>

  </div>

  <hr class="select-datepicker-list__divider">

  <div class="select-datepicker-list__items">

    <div *ngFor="let item of activePageItems"
         (click)="select(item)"
         class="select-datepicker-list__item">
      {{ item }}
    </div>

  </div>
</div>
